import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ContactUsForm from '@/views/components/feedback/ContactUsForm.vue';
import ManualComponent from '@/views/components/ManualComponent.vue';
import ReleaseNotesComponent from '@/views/components/releaseNotes/ReleaseNotesComponent.vue';
import WPReleaseNotesList from '@/views/components/releaseNotes/WPReleaseNotesList.vue';
import AppConfig from '@/configLoader';
import ReleaseNotesRepository from '@/services/repository/ReleaseNotesRepository';
var releaseNotesRepository;
let About = class About extends Vue {
    constructor() {
        super(...arguments);
        this.currentConfig = AppConfig.getConfig();
        this.posts = [];
        this.isLoadingReleaseNotes = true;
    }
    get feedbackFeatureIsTurnedOn() {
        return AppConfig.getConfig().features.feedback == true;
    }
    get wpReleaseNotesFeatureIsTurnedOn() {
        return AppConfig.getConfig().features.wp_release_notes == true;
    }
    created() {
        releaseNotesRepository = new ReleaseNotesRepository(this);
        this.loadPosts();
    }
    async loadPosts() {
        if (this.wpReleaseNotesFeatureIsTurnedOn) {
        }
        this.posts = await releaseNotesRepository.getAllReleaseNotesPreview();
        this.isLoadingReleaseNotes = false;
    }
};
About = __decorate([
    Component({ components: { ContactUsForm, ReleaseNotesComponent, ManualComponent, WPReleaseNotesList } })
], About);
export default About;
